require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./masala-dabba-theuninternationalyearofplanthealth.json") })
        }
      }, "path---masala-dabba-theuninternationalyearofplanthealth");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---masala-dabba-theuninternationalyearofplanthealth!./.cache/json/masala-dabba-theuninternationalyearofplanthealth.json
// module id = 720
// module chunks = 231608221292675